module.exports = __webpack_public_path__ + "static/media/skywell.93ec1bed.png";